import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";

import Box from "components/Box";
import Card, { CardActionArea } from "components/Card";
import Stack from "components/Stack";
import Text from "components/Text";

import { useCompanySettings } from "entities/Company/sdk";
import { EMemoSectionType } from "entities/MemoTemplate/constants";

import { MEMO_SECTION_GROUPS } from "./constants";

export interface IMemoTemplateSectionSelector {
  value: EMemoSectionType;
  onChange: (value: EMemoSectionType) => void;
  disabled?: boolean;
}

const MemoTemplateSectionSelector = ({
  disabled = false,
  value: selectedValue,
  onChange,
}: IMemoTemplateSectionSelector) => {
  const { data: companySettings } = useCompanySettings();

  const filteredMemoSectionGroups = useMemo(() => {
    return {
      ...MEMO_SECTION_GROUPS,
      Custom: companySettings?.onboarding_company_package_enabled
        ? MEMO_SECTION_GROUPS.Custom
        : MEMO_SECTION_GROUPS.Custom.filter(
            (section) => section.value !== EMemoSectionType.AI_ANSWER
          ),
    };
  }, [companySettings?.onboarding_company_package_enabled]);
  return (
    <Stack spacing={1}>
      {_.map(filteredMemoSectionGroups, (sectionTypes, sectionGroupName) => (
        <Box>
          <Text variant="text3">{sectionGroupName}</Text>
          <Stack
            direction="row"
            sx={{
              padding: 1,
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              border: `1px dashed ${colors.blue20}`,
            }}
          >
            {_.map(sectionTypes, ({ label, value, icon }, key) => (
              <Card
                key={key}
                sx={{
                  height: "100%",
                  backgroundColor:
                    value === selectedValue ? colors.blue20 : "white",
                }}
              >
                <CardActionArea
                  disabled={disabled}
                  sx={{ height: "100%" }}
                  onClick={() => !disabled && onChange(value)}
                >
                  <Stack
                    spacing={0}
                    justifyContent="stretch"
                    alignItems="center"
                    sx={{ padding: 1, height: "100%" }}
                  >
                    {icon}
                    <Text align="center" variant="text4">
                      {label}
                    </Text>
                  </Stack>
                </CardActionArea>
              </Card>
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};

export default MemoTemplateSectionSelector;
